module.exports = __webpack_public_path__ + "img/logo-venteny.746babc3.svg";